<template>
    <div id="app">
        <div
            v-if="
                this.$store.state.user.sessionId ||
                this.$route.name == 'login' ||
                this.$route.name == 'window'
            "
            class="router-view"
        >
            <template v-if="$route.meta.hiddenNavigation">
                <keep-alive>
                    <router-view
                        class="view-router"
                        v-if="$route.meta.keepAlive"
                        style="height: 100vh; overflow: hidden"
                    ></router-view>
                </keep-alive>
                <router-view
                    class="view-router"
                    v-if="!$route.meta.keepAlive"
                    style="height: 100vh; overflow: hidden"
                ></router-view>
            </template>
            <template v-else>
                <v-nav></v-nav>
                <div>
                    <keep-alive>
                        <router-view
                            class="view-router"
                            v-if="$route.meta.keepAlive"
                            style="height: 100vh; overflow: hidden"
                        ></router-view>
                    </keep-alive>
                    <router-view
                        class="view-router"
                        v-if="!$route.meta.keepAlive"
                        style="height: 100vh; overflow: hidden"
                    ></router-view>
                </div>
            </template>
        </div>
        <div v-else>您当前未登录</div>
    </div>
</template>
<script>
import { url } from "@/assets/js/config";
import axios from "axios";
import SockJS from "sockjs-client";
import Stomp from "stompjs";

export default {
    data() {
        return {
            stompClient: null,
            timeOutForReconnect: null,
        };
    },
    components: {},
    created() {
        if (window.location.href.search("window") != "-1") {
            return;
        }

        let sessionId = localStorage.getItem("sessionId");

        if (sessionId) {
            this.$reqPost("/api/userInfo/get", {}).then(
                (res) => {
                    this.$store.state.user = res.data.returnData;
                    this.$store.state.user.sessionId = sessionId;
                },
                (err) => {
                    this.$router.replace("/login");
                }
            );
        } else {
            this.$router.replace("/login");
        }
    },
    mounted() {},
    methods: {
        initSock() {
            let that = this;
            if (that.stompClient) {
                that.closeSock();
            }
            let socketUrl = `${url().baseUrl}/api/ws`; //连接地址
            // 建立连接对象（还未发起连接）
            let socket = new SockJS(socketUrl);
            // 获取 STOMP 子协议的客户端对象
            that.stompClient = Stomp.over(socket);
            //客户端发出心跳5s间隔
            that.stompClient.heartbeat.outgoing = 5000;
            //客户端接收服务端心跳5s间隔 0表示不接收
            that.stompClient.heartbeat.incoming = 5000;
            // 向服务器发起websocket连接并发送CONNECT帧
            that.stompClient.connect(
                { "x-auth-token": that.$store.state.user.sessionId }, //可添加客户端的认证信息
                function connectCallback(frame) {
                    //连接成功的回调函数
                    //订阅频道
                    that.stompClient.subscribe(
                        "/user/queue/notify",
                        function (data) {
                            if (data) {
                                let obj = JSON.parse(data.body);

                                Notification.requestPermission(function (
                                    status
                                ) {
                                    let text = "";
                                    if (obj.msgType == "text") {
                                        text = obj.content;
                                    }
                                    if (obj.msgType == "image") {
                                        text = "[图片消息]";
                                    }
                                    let n = new Notification(
                                        `客户${obj.sendUserName}发送了一条消息`,
                                        {
                                            body: text,
                                            data: {
                                                url: "https://51zl.zcunsoft.com/pub/",
                                            },
                                            renotify: false,
                                            tag: that.$guid(32),
                                            //通知声源文件地址。非必须，默认为空
                                            sound: "http://51zl-pro-oss.zcunsoft.com/sounds/messages.mp3",
                                            icon: that.$store.state.user
                                                .appAvatar,
                                        }
                                    ); // 显示通知

                                    n.onclick = function (e) {
                                        window.open(n.data.url, "_blank");
                                        n.close();
                                    };
                                });
                            }
                        }
                    );
                },
                function errorCallBack(error) {
                    console.log("STOMP: " + error);
                    that.timeOutForReconnect = setTimeout(() => {
                        that.initSock();
                    }, 5000);
                    console.log("STOMP: Reconnecting in 5 seconds");
                }
            );
        },
        closeSock() {
            if (this.stompClient) {
                console.log("断开");
                clearTimeout(this.timeOutForReconnect);
                this.stompClient.disconnect(function () {});
                this.stompClient = null;
            }
        },
        active() {
            if (this.$store.state.user.sessionId) {
                this.$reqPost("/api/user/status/active", {}).then(
                    (res) => {},
                    (err) => {}
                );
            }
        },
    },
    beforeMount() {},
    watch: {
        "$store.state.user.sessionId"() {
            if (this.$store.state.user.sessionId) {
                if (
                    this.$store.state.user.myRole == "ticket_service" ||
                    this.$store.state.user.myRole == "ticket_manager"
                ) {
                    this.$router.replace("/workOrder/myWorkOrder");
                } else {
                    this.$router.replace("/");
                }

                this.active();
                setInterval(() => {
                    this.active();
                }, 30000);
            }
        },
        "$store.state.user.receiveWebsocketNotify"() {
            console.log("用户设置改变");
            if (this.$store.state.user.receiveWebsocketNotify) {
                this.initSock();
            } else {
                this.closeSock();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.router-view {
    height: 100%;
}
</style>
<style lang="scss" src="./assets/scss/global.scss" />
<style lang="scss" src="./assets/scss/secondary-menu.scss" />


// WEBPACK FOOTER //
// src/App.vue